"use client";

import dynamic from "next/dynamic";

export const LazyBrandBanner = dynamic(() => import("./BrandBanner"));
